// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"512":"732ded1f","620":"9d111627"}[chunkId] + ".chunk.css";
};